// extracted by mini-css-extract-plugin
export var option = "_9f-0";
export var optionCard = "_9f-f";
export var optionContent = "_9f-g";
export var optionIcon = "_9f-i";
export var optionIconBox = "_9f-h";
export var optionLabel = "_9f-j";
export var optionPill = "_9f-m";
export var optionPillBadge = "_9f-p";
export var optionPillIcon = "_9f-n";
export var optionPillLabel = "_9f-o";
export var optionRadio = "_9f-k";
export var optionRadioInner = "_9f-l";
export var optionReveal = "_9f-2";
export var optionRevealDelay0 = "_9f-3";
export var optionRevealDelay1 = "_9f-4";
export var optionRevealDelay10 = "_9f-d";
export var optionRevealDelay11 = "_9f-e";
export var optionRevealDelay2 = "_9f-5";
export var optionRevealDelay3 = "_9f-6";
export var optionRevealDelay4 = "_9f-7";
export var optionRevealDelay5 = "_9f-8";
export var optionRevealDelay6 = "_9f-9";
export var optionRevealDelay7 = "_9f-a";
export var optionRevealDelay8 = "_9f-b";
export var optionRevealDelay9 = "_9f-c";
export var optionSelected = "_9f-1";